import { graphql, useStaticQuery } from 'gatsby';

function usePageData() {
  const data = useStaticQuery(graphql`
    {
      allWpCategory(filter: { count: { gt: 0 } }) {
        edges {
          node {
            name
            id
            slug
            description
          }
        }
      }
      contentfulPage(nameid: { eq: "Categories Page" }) {
        metaTitle
        metaDescription {
          metaDescription
        }
      }
    }
  `);
  return data;
}

export default usePageData;
